import { useLocation, useNavigate, Navigate } from "react-router-dom";
import CollectionsPage from "./CollectionsPage";
import GarmentsPage from "./GarmentsPage";
import { PageHeader } from "../components/ui-bits";
import { useT } from "../lib/i18n";

export default function CollectionsGarmentsPage() {
  const loc = useLocation();
  const nav = useNavigate();
  const t = useT();
  const params = new URLSearchParams(loc.search);
  const tab = params.get("tab") === "garments" ? "garments" : "collections";

  const setTab = (v) => {
    const p = new URLSearchParams(loc.search);
    p.set("tab", v);
    nav(`/collections-garments?${p.toString()}`, { replace: false });
  };

  return (
    <div data-testid="collections-garments-page">
      <PageHeader
        eyebrow={t("collections_garments.eyebrow")}
        title={tab === "garments" ? t("garments.title") : t("collections.title")}
        description={tab === "garments" ? t("garments.desc") : t("collections.desc")}
      />
      <div className="flex gap-1 border-b mb-6" style={{ borderColor: "var(--border)" }}>
        <button
          type="button"
          data-testid="tab-collections"
          onClick={() => setTab("collections")}
          className="px-5 py-3 text-xs uppercase tracking-widest border-b-2"
          style={{
            color: tab === "collections" ? "var(--text-primary)" : "var(--text-secondary)",
            borderColor: tab === "collections" ? "var(--text-primary)" : "transparent",
          }}
        >
          {t("tab.collections")}
        </button>
        <button
          type="button"
          data-testid="tab-garments"
          onClick={() => setTab("garments")}
          className="px-5 py-3 text-xs uppercase tracking-widest border-b-2"
          style={{
            color: tab === "garments" ? "var(--text-primary)" : "var(--text-secondary)",
            borderColor: tab === "garments" ? "var(--text-primary)" : "transparent",
          }}
        >
          {t("tab.garments")}
        </button>
      </div>
      <div style={{ display: tab === "collections" ? "block" : "none" }}>
        <CollectionsPage embedded/>
      </div>
      <div style={{ display: tab === "garments" ? "block" : "none" }}>
        <GarmentsPage embedded/>
      </div>
    </div>
  );
}

export function RedirectToCollectionsTab() { return <Navigate to="/collections-garments?tab=collections" replace/>; }
export function RedirectToGarmentsTab() { return <Navigate to="/collections-garments?tab=garments" replace/>; }
